import React from 'react';
import { Cpu } from 'lucide-react';

// IoT Devices module — placeholder. The device registry (sensors, trackers,
// alarms…) will be implemented here later; the sidebar entry and route are
// wired up so the module can be filled in without touching navigation.
const IoTDevices = () => (
  <div className="h-screen bg-gray-50 flex flex-1 overflow-hidden">
    <div className="flex-1 p-6 overflow-y-auto">
      <div className="mb-6">
        <h2 className="text-2xl font-bold text-gray-800 mb-2">IoT Devices</h2>
        <p className="text-sm text-gray-600">
          Registry of connected field devices — sensors, trackers, alarms and other smart equipment.
        </p>
      </div>

      <div className="bg-white rounded-xl border border-gray-200 shadow-sm text-center py-20" data-testid="iot-devices-empty">
        <span className="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-2xl bg-indigo-50">
          <Cpu className="h-7 w-7 text-indigo-400" />
        </span>
        <p className="text-sm font-semibold text-gray-600">IoT Devices module coming soon</p>
        <p className="text-xs text-gray-400 mt-1 max-w-sm mx-auto">
          This module is reserved for registering and monitoring IoT devices used during incidents and drills.
        </p>
      </div>
    </div>
  </div>
);

export default IoTDevices;
